import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

export interface EmdCityCoord {
  city: string;
  state_id: string;
  lat: number | string;
  lng: number | string;
}

export interface EmdMapReference {
  cityCoords: EmdCityCoord[];
  statesTopojson: any;
}

/**
 * US state boundaries and city coordinates for the wholesaler map.
 *
 * Reads the app's existing static asset directly rather than going through
 * FilterService, so the EMD charts depend on no app-wide singleton. The result
 * is cached because the file is ~5MB and the Summary tab is rebuilt on every
 * tab switch.
 */
@Injectable({ providedIn: 'root' })
export class EmdMapDataService {
  private cache$?: Observable<EmdMapReference>;

  constructor(private readonly http: HttpClient) {}

  load(): Observable<EmdMapReference> {
    return (this.cache$ ??= this.http
      .get<EmdMapReference>('assets/json/DispenseTrendDataWeeklyBubble.json')
      .pipe(shareReplay(1)));
  }
}
